import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// ==============================|| TYPES ||============================== //

interface Plan {
    id: string;
    title: string;
    price: number;
    statementDescriptor: string;
    totalUsers: number;
    featureList: string;
}

interface PlanState {
    selectedPlan: Plan;
    updatedPlanSnackBar: string;
    totalActiveUsers: number;
    maxPlanUsers: number;
}

// initial state
const initialState: PlanState = {
    selectedPlan: {
        id: 'dev_Free',
        title: 'Free',
        price: 0,
        statementDescriptor: 'Default Free Plan',
        totalUsers: 1,
        featureList: 'One User, Many Requests'
    },
    updatedPlanSnackBar: '',
    totalActiveUsers: 1,
    maxPlanUsers: 1
};

// ==============================|| SLICE - PLAN ||============================== //

const planSlice = createSlice({
    name: 'plan',
    initialState,
    reducers: {
        selectPlan(state, action: PayloadAction<Plan>) {
            state.selectedPlan = action.payload;
        },

        setMaxPlanUsers(state, action: PayloadAction<number>) {
            state.maxPlanUsers = action.payload;
        },

        setTotalActiveUsers(state, action: PayloadAction<number>) {
            state.totalActiveUsers = action.payload;
        }
    }
});

export default planSlice.reducer;

export const { selectPlan, setMaxPlanUsers, setTotalActiveUsers } = planSlice.actions;
